export const capitalizeText = (text) => {
    return text?.toString()?.toLowerCase()?.replace(/\b\w/g, c => c.toUpperCase())
}

export const setBrowserTitle = (title) => {
    if (title) { document.title = `${capitalizeText(title)} | School Portal`; return }
    document.title = `School Portal`;
}

export const FORMNAMES = {
    SCHOOLPROFILE: "school_profile",
    SCHOOLBANNERS: "school_banners",
    SCHOOLINFRASTUCTURE: "school_infrastructure",
    SCHOOLAPPROACH: "school_approach",
    SCHOOLDIGNATORIES: "school_dignitaries",
    SCHOOLFEATURES: "school_features",
    SCHOOLGALLERY: "school_gallery",
    STUDENTS: "student_information",
    TOPPER_STUDENTS: "top_students",
    STAFFINFORMATION: "staff_information",
    CONTACTUS: "contact_us",
    DYANAMICFORM: "dynamic_pages",
    NOTICE: "notice",
    CALENDAREVENTS: "calendar"
}

export const formatDate = (date) => {
    return new Date(date)
        .toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        })
        .replace(",", "")
        .replace(/\b(am|pm)\b/, (m) => m.toUpperCase());
}

